import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { toast } from 'react-toastify';
import logoImg from '../assets/images/Logo2.PNG'; 
import API from '../pages/Api'; 
import SansmrutiBookReleases from './SansmrutiPublicationPages/SansmrutiBookReleases';

const LoginForm = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false); 

    // --- 1. LOGIN LOGIC ---
    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await API.post('login/', {
                emailid: email,
                password: password
            });
            console.log(response);
            
            // localStorage.setItem('access_token', response.data.access);
            // localStorage.setItem('refresh_token', response.data.refresh);
            
            // const userData = {
            //     name: response.data.name,
            //     emailid: email, 
            //     roleid: response.data.roleid
            // };
            // localStorage.setItem('user', JSON.stringify(userData));
            // localStorage.setItem('userName', response.data.name);


            localStorage.setItem('access_token', response.data.access);
        localStorage.setItem('refresh_token', response.data.refresh);

        // Store complete user data
        Object.keys(response.data).forEach((key) => {
            localStorage.setItem(key, JSON.stringify(response.data[key]));
        });

        // Optional: store complete user object separately
        localStorage.setItem('user', JSON.stringify(response.data))
            
            const role = String(response.data.roleid); 
            localStorage.setItem('role', role); 

            if (role === "1") {
                navigate("/TGSH/admin/home"); 
            } else {
                navigate("/TGSH/user/dashboard"); 
            }
        } catch (error) {
            console.error("Login Error:", error);
            const errorMsg = error.response?.data?.detail || "Login failed! Please check your credentials.";
            toast.error(errorMsg);
        }
    };

    // --- 2. FORGOT PASSWORD LOGIC ---
    const handleForgotPassword = () => {
        navigate('/TGSH/forgot-password');
    };

    const handleRegisterRedirect = () => {
        navigate('/TGSH/register'); 
    };

    return (
        <div style={overlayStyle}>
            <div style={modalStyle}>
                <button onClick={() => navigate('/TGSH')} style={closeButtonStyle}>&times;</button>
                <div className="login-container">
                    
                    {/* Left Section with Logo */}
                    <div style={leftSectionStyle}>
                        <img
                            src={logoImg}
                            alt="Global School Logo"
                            style={{
                                width: '100%',
                                maxWidth: '300px',
                                height: 'auto'
                            }}
                        />
                    </div>

                    {/* Right Section with Form */}
                    <div style={rightSectionStyle}>
                        <h2
                            style={{
                                color: '#032167',
                                marginBottom: '25px',
                                letterSpacing: '1px',
                                fontSize: '32px',
                                fontWeight: '700'
                            }}
                        >
                            SIGN IN
                        </h2>
                        <form onSubmit={handleLogin} style={{ textAlign: 'left', width: '100%' }}>
                            <label style={labelStyle}>Email Address</label>
                            <input 
                                type="email" 
                                style={inputStyle} 
                                value={email} 
                                onChange={(e) => setEmail(e.target.value)} 
                                placeholder="Enter your email"
                                required 
                            />
                            
                            <label style={labelStyle}>Password</label>
                            <div style={{ position: 'relative' }}> 
                                <input 
                                    type={showPassword ? "text" : "password"} 
                                    style={inputStyle} 
                                    value={password} 
                                    onChange={(e) => setPassword(e.target.value)} 
                                    placeholder="Enter your password"
                                    required 
                                />
                                <span 
                                    onClick={() => setShowPassword(!showPassword)} 
                                    style={eyeIconStyle}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>

                            {/* Forgot Password Link */}
                            <div style={{ textAlign: 'right', marginTop: '-15px', marginBottom: '20px' }}>
                                <span 
                                    onClick={handleForgotPassword} 
                                    style={linkStyle}
                                >
                                    Forgot Password?
                                </span>
                            </div>

                            <button type="submit" style={loginButtonStyle}>Login</button>
                        </form>

                        {/* Registration Link */}
                        <div style={{ marginTop: '25px', fontSize: '14px', color: '#555' }}>
                            Not a member? {' '}
                            <span 
                                onClick={handleRegisterRedirect} 
                                style={{ ...linkStyle, fontWeight: 'bold', color: '#54a50f' }}
                            >
                                Register Now
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Styles
const overlayStyle = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000 };
const modalStyle = {
  backgroundColor: '#fff',
  width: '95%',
  maxWidth: '900px',
  borderRadius: '20px',
  overflow: 'hidden',
  position: 'relative',
  boxShadow: '0 25px 50px rgba(0,0,0,0.3)',
  maxHeight: '95vh',
  overflowY: 'auto'
};
// const containerStyle = { display: 'flex', flexWrap: 'wrap' };
const leftSectionStyle = {
  flex: '1',
  backgroundColor: '#f0f4f1',
  padding: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};
const rightSectionStyle = {
  flex: '1.2',
  padding: '30px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};
const labelStyle = { fontSize: '12px', fontWeight: 'bold', color: '#888', marginLeft: '5px' };
const inputStyle = {
  width: '100%',
  padding: '14px',
  margin: '8px 0 20px 0',
  border: '1px solid #e0e0e0',
  borderRadius: '10px',
  backgroundColor: '#f9f9f9',
  outline: 'none',
  fontSize: '16px'
};
const loginButtonStyle = {
  width: '100%',
  padding: '15px',
  backgroundColor: '#54a50f',
  color: 'white',
  border: 'none',
  borderRadius: '10px',
  fontWeight: 'bold',
  fontSize: '16px',
  cursor: 'pointer',
  marginTop: '10px',
  transition: '0.3s'
};
const closeButtonStyle = {
  position: 'absolute',
  top: '12px',
  right: '15px',
  background: 'none',
  border: 'none',
  fontSize: '32px',
  cursor: 'pointer',
  color: '#aaa',
  zIndex: 100
};
const linkStyle = { color: '#032167', cursor: 'pointer', fontSize: '13px', textDecoration: 'none' };


const eyeIconStyle = {
    position: 'absolute',
    right: '12px',
    top: '40%', 
    transform: 'translateY(-50%)', 
    cursor: 'pointer',
    color: '#888',
    fontSize: '18px',
    display: 'flex',
    alignItems: 'center'
};

export default LoginForm;